import { createSelector } from 'reselect';

export const selectToken = createSelector(
  (state) => state.auth,
  (auth) => auth.token,
);

export const selectUserName = createSelector(
  (state) => state.auth,
  (auth) => auth.userName,
);

export const selectUserCountry = createSelector(
  (state) => state.auth,
  (auth) => auth.userCountry,
);

export const selectAuthLoading = createSelector(
  (state) => state.auth,
  (auth) => auth.isLoading,
);

export const selectIsLoggedIn = createSelector(
  (state) => state.auth,
  (auth) => auth.isLoggedIn,
);

export const selectLoginError = createSelector(
  (state) => state.auth,
  (auth) => auth.loginState.loginError,
);

export const selectUserEmail = createSelector(
  (state) => state.auth,
  (auth) => auth.userEmail,
);

export const selectUserData = createSelector(
  (state) => state.auth,
  (auth) => ({
    userId: auth.userId,
    userName: auth.userName,
    userEmail: auth.userEmail,
    userCountry: auth.userCountry,
  }),
);
